/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

const textProp = PropTypes.shape({
  key: PropTypes.string,
  value: PropTypes.string,
});

const textFieldProp = PropTypes.shape({
  label: textProp.isRequired,
  error: textProp,
});

export const emailUsFormText = PropTypes.shape({
  formFieldName: textFieldProp.isRequired,
  formFieldEmail: textFieldProp.isRequired,
  formFieldOrderNum: textProp.isRequired,
  formFieldDropDown: textFieldProp.isRequired,
  formFieldComments: textFieldProp.isRequired,
  formReasons: textProp.isRequired,
  formError: textProp.isRequired,
});

export const emailUsFormTextV2 = PropTypes.shape({
  formFieldName: textFieldProp.isRequired,
  formFieldEmail: textFieldProp.isRequired,
  formFieldOrderNum: textProp.isRequired,
  formFieldDropDown: textFieldProp.isRequired,
  formFieldComments: textFieldProp.isRequired,
  formReasons: textProp.isRequired,
  formError: textProp.isRequired,
  formFieldDetails: textFieldProp.isRequired,
  formFieldFirstName: textFieldProp.isRequired,
  formFieldLastName: textFieldProp.isRequired,
  modalHeading: textProp.isRequired,
  formResponseNote: textProp.isRequired,
  formLegal: textProp.isRequired,
  formWhatDoYouNeedHelpWith: textProp.isRequired,
  formContinueButton: textProp.isRequired,
  formGotItButton: textProp.isRequired,
  formDisputeLabel: textProp,
  formOrderNumberTooltipContent: textProp,
  formOrderNumberToolTipLabel: textProp,
  formOrderShipArriveDirections: textProp,
  formCancelOrderDirections: textProp,
  formReturnExchangeDirections: textProp,
  formYouAreTakenToEmail: textProp,
  formServiceRequestNote: textProp,
  formGoToEmail: textProp,
  formRequiredField: textProp.isRequired,
  formEmailUsHeading: textProp.isRequired,
  buttonProcessing: textProp.isRequired,
  buttonSubmit: textProp.isRequired,
  buttonSuccess: textProp.isRequired,
  formFieldOrderNumber: textFieldProp.isRequired,
  formFieldEmailAddress: textFieldProp.isRequired,
});
